
import React from "react";
function PageRedirect() {
	window.location.replace('https://gbayouthforum.org.hk/');
}

export default PageRedirect;